export const cardData = {
  0: [
    "所有玩家想出三個代表自己的標籤，並順時針逐一分享選擇的原因。",
    "所有玩家打開手機，挑一張最近拍的照片並説説它的故事。",
    "所有玩家分享一句深刻影響你的話，並逐一分享！",
    "所有玩家一起合照一張！並上傳打卡！",
    "所有玩家分享兩件今日想感恩的事情。",
    "你認為你的形象是什麼？你做過什麼與你形象不符的事（所有玩家回答）。",
    "抽到卡的人，指定兩位玩家扮最醜的鬼臉！並合影一張做紀錄。",
    "所有玩家用十秒唱一首最喜歡的歌。",
    "所有玩家分享你小時候的樣子給大家看！",
    "所有玩家分享平常都是如何表達「愛」？"
  ],
  1: [
    "小時候最喜歡的一部卡通或動畫是什麼？",
    "工作或學習之餘，你最常做的休閒活動是什麼？",
    "分享一個最近讓你覺得好笑或開心的時刻。",
    "分享一個最近讓你感到幸運的事情。",
    "如果可以跟任何一位名人一起吃飯，你會選擇？",
    "你最喜歡收到什麼樣子的禮物？",
    "有沒有哪一本書或哪一部電影，讓你看完印象深刻？",
    "你覺得自己比較像外相還是內向的人？有沒有具體的例子？",
    "如果能夠回到某個特定年齡，你會想回到幾歲？",
    "你覺得自己在社交中最大的優勢是什麼？",
    "你認為最能讓你放鬆或療癒的事情是什麼？",
    "邀請大家說說對你的第一印象？（由所有玩家回應抽卡人）",
    "請大家分享最想對你說的一句話，可能是感謝、稱讚或祝福（由所有玩家回應抽卡人）",
    "送大家你很喜歡的一段話，它如何影響你？",
    "分享人生的第一份工作與心境，有什麼特別的回憶嗎？",
    "分享一份近期生活中得到的體悟？",
    "你想要在生活中融入什麼樣的新習慣？",
    "你覺得維持一段友誼最重要的元素是什麼？",
    "關於童年，你最難忘的回憶是什麼？",
    "如果你能瞬間掌握一種才藝，你會選什麼？"
  ],
  2: [
    "什麼事是你知道要改變，但總是告訴自己還有時間？",
    "對一位玩家說出你心中的感謝。記得給一個擁抱。",
    "你認為自己在哪些方面成長最多？它是否來自什麼關鍵事件或人物？",
    "有沒有哪件事當時讓你感到心碎，但現在回想起來已經可以微笑面對？",
    "如果不會被嘲笑或反對，你最想完成什麼事情？",
    "描述一次你覺得自己被照亮的時刻（精準地說出你的特質與優點）？",
    "分享一個現在生活中最喜歡的部分？他滿足了你內心什麼樣的需求？",
    "嘉許在場某一人的行為、特質或是共同經歷的回憶。他對你產了什麼影響？",
    "什麼樣的行為最令你憤怒？你都如何表達憤怒？",
    "你最近一次對父母撒謊是什麼時候？是什麼事件？",
    "你會如何表達關心或在乎？身邊的人都能收到嗎？",
    "大家會如何向陌生人介紹我呢？（由所有玩家回應抽卡人）",
    "最近有沒有什麼時刻讓你紅了眼匡？",
    "有沒有哪一次你覺得自己的感受與需求被重要的人忽視？當時你的反應是什麼？",
    "你覺得自己身上最值得驕傲的特質是什麼？",
    "描述一次你克服恐懼的經歷，當時發生了什麼？",
    "大家認為跟你有哪些相似之處？特質、個性或是談吐（由所有的玩家回應抽卡人）",
    "你會如何形容自己家庭中你所扮演的角色？家庭成員也是這樣看待你嗎？",
    "你認為一段理想的關係，需要具備哪些特質？為什麼？",
    "最近有沒有誰說過一句話，或做過一件事，讓你覺得「他真的懂我」"
  ],
  3: [
    "分享你與父母之間印象最深刻的一個回憶？",
    "如果可以回到過去刪除某一個記憶，那會是什麼樣的事件？重來一次的話，你會怎麼做？",
    "如果可以重塑與某人的關係，你最希望改變哪個部分？為什麼？",
    "説出一個你在群體或關係中最令你驕傲的特質？你怎麼發現的？",
    "分享一個你印象深刻的失敗經歷，描述當初的感受，以及你現在如何看待它？",
    "分享一個你一直想做但至今都未完成的事情？如果選擇完成它，該克服的挑戰是什麼？",
    "分享生命中最讓你感到幸福的時刻？是什麼讓它如此特別？",
    "如果現在有機會對一個人說出你的歉意或感謝，你會選誰？",
    "你認為過去一年裡，你最大的成長是什麼？",
    "最近一次讓你感到內疚的事情是什麼？",
    "你曾經做過最勇敢的決定是什麼？分享一下當時的心境為何？",
    "在家庭關係中你最想改變的是什麼？最需要克服的是什麼？",
    "分享人際關係中你最想被珍惜的是什麼？你也珍惜跟你有相同特點的人嗎？",
    "談一談你正在面對的人生課題，阻礙你的是什麼？你認為自己會怎麼突破？",
    "分享一件你曾全力以赴達成的一件事，當時你有什麼心情？為了什麼而去努力？",
    "想像一個完美的「療愈日」你會怎麼安排？哪些元素對你來說是最具療癒效果？",
    "你覺得怎樣的經歷能讓人重新認識自己？分享一件關於你的人生轉折點。",
    "你曾經完成過的最有成就感的一件事是什麼？你是如何完成的？",
    "在生命最後的時刻，你會最感謝自己做過哪個決定？",
    "面對壓力與挑戰時，你如何給予自己力量與信心？"
  ]
};

export const levelColors = {
  0: '#90EE90',  // Light green
  1: '#87CEEB',  // Sky blue
  2: '#DDA0DD',  // Plum
  3: '#FFB6C1'   // Light pink
};

export const levelNames = {
  0: '暖身破冰 - Break The Ice',
  1: '一星連結 - One Star Connection',
  2: '二星連結 - Two Star Connection',
  3: '三星連結 - Three Star Connection'
};
